import instanceAxios from '../config/api'
import {
  CalculateIncidentActionsCostsResponse,
  Incident,
  IncidentResponse,
  MapIncidentToAuditsResponse,
  SourceIncidentType,
} from '../types/incidentTypes'

const API_URL = '/incidents'

export const getAllIncidents = async ({
  page,
  pageSize,
  search,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<IncidentResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch incidents.')
  }
}

export const deleteIncidentApi = async (id: string) => {
  try {
    const response = await instanceAxios.delete<IncidentResponse>(
      `${API_URL}/` + id
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch incidents.')
  }
}

export const getIncidentbyIdApi = async (IncidentId: string) => {
  try {
    const response = await instanceAxios.get<Incident>(
      `${API_URL}/` + IncidentId
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch incident.')
  }
}

export const updateIncidentApi = async (
  updatedIncident: Incident,
  IncidentId: string
): Promise<Incident> => {
  try {
    const response = await instanceAxios.put<Incident>(
      `${API_URL}/${IncidentId}`,
      updatedIncident
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUT Incident.')
  }
}

export const addIncidentApi = async (
  newIncident: Incident
): Promise<Incident> => {
  try {
    const response = await instanceAxios.post<Incident>(
      `${API_URL}/`,
      newIncident
    )
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add incident.')
  }
}
export const getIncidentsByMissionIdApi = async (MissionId: string) => {
  try {
    const response = await instanceAxios.get<IncidentResponse>(
      `missions/getIncidents/` + MissionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch incident.')
  }
}

export const getIncidentByActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<IncidentResponse>(
      `actions/getIncidents/` + ActionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch Incident.')
  }
}
export const addIncidentsToActionApi = async (
  SourceIncident: string[],
  _id: string
): Promise<IncidentResponse> => {
  try {
    const response = await instanceAxios.put<IncidentResponse>(
      `actions/addIncidents/${_id}`,
      SourceIncident
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}

export const removeIncidentsFromActionApi = async (
  SourceIncident: SourceIncidentType,
  _id: string
): Promise<IncidentResponse> => {
  try {
    const response = await instanceAxios.put<IncidentResponse>(
      `actions/removeIncidents/${_id}`,
      SourceIncident
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}
export const mapIncidentToAuditsApi = async (
  id: string
): Promise<MapIncidentToAuditsResponse> => {
  try {
    const response = await instanceAxios.get<MapIncidentToAuditsResponse>(
      `incidents/mapIncidentToAudits/${id}`
    )
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('Failed to map incident to audits.')
  }
}
export const calculateIncidentActionsCostsApi = async (
  id: string
): Promise<CalculateIncidentActionsCostsResponse> => {
  try {
    const response =
      await instanceAxios.get<CalculateIncidentActionsCostsResponse>(
        `incidents/calculateIncidentActionsCosts/${id}`
      )
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('Failed to calculate incident actions costs.')
  }
}
